import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem 1rem;
  margin: 0px 10px;
  max-width: 50rem;
  max-height: 51rem;
  overflow: auto;

  p {
    font-size: 20px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 32px;
    line-height: 1.6;
    letter-spacing: 0.1px;
    word-wrap: break-word;
    -webkit-font-smoothing: antialiased;
    text-align: justify;
    text-justify: inter-word;
  }
`;
